import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    accountPath: String,
    facilitatorPath: String,
    billingPath: String
  }

  syncPath(event) {
    const tab = event.detail?.activeTab
    if (!tab) return

    const path = this.pathFor(tab)
    if (!path) return

    const current = `${window.location.pathname}${window.location.search}`
    if (current !== path) {
      history.replaceState(null, "", path)
    }
  }

  pathFor(tab) {
    switch (tab) {
    case "account":
      return this.accountPathValue
    case "facilitator":
      return this.facilitatorPathValue
    case "billing":
      return this.billingPathValue
    default:
      return null
    }
  }
}
